import { compose } from 'recompose'
import { connect } from 'react-redux'
import omitProps from './omitProps'
import { selectUserIdPair } from 'src/store/selectors/layout'

const fetchClientInfoOnMountAndUpdate = compose(
  connect(state => selectUserIdPair(state)),
  omitProps('id', 'legacyId', 'fetch')
)

export default fetchClientInfoOnMountAndUpdate
